/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseTehtrisTriggers } from './GetIntegrationsConfig200ResponseTehtrisTriggers';
import {
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSONTyped,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSONTyped,
} from './GetIntegrationsConfig200ResponseTehtrisTriggers';
import type { GetIntegrationsConfig200ResponseAutotaskPriorities } from './GetIntegrationsConfig200ResponseAutotaskPriorities';
import {
    GetIntegrationsConfig200ResponseAutotaskPrioritiesFromJSON,
    GetIntegrationsConfig200ResponseAutotaskPrioritiesFromJSONTyped,
    GetIntegrationsConfig200ResponseAutotaskPrioritiesToJSON,
    GetIntegrationsConfig200ResponseAutotaskPrioritiesToJSONTyped,
} from './GetIntegrationsConfig200ResponseAutotaskPriorities';

/**
 * 
 * @export
 * @interface GetIntegrationsConfig200ResponseAutotask
 */
export interface GetIntegrationsConfig200ResponseAutotask {
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    apiUserName: string;
    /**
     * 
     */
    companyId: number;
    /**
     * 
     */
    statusId: number;
    /**
     * 
     */
    priorities: GetIntegrationsConfig200ResponseAutotaskPriorities;
    /**
     * 
     */
    queueId?: number;
    /**
     * 
     */
    billingCodeId?: number;
    /**
     * 
     */
    ticketTypeId?: number;
    /**
     * 
     */
    dueInDays: number;
    /**
     * 
     */
    triggers: GetIntegrationsConfig200ResponseTehtrisTriggers;
    /**
     * 
     */
    hasSecret: boolean;
}

/**
 * Check if a given object implements the GetIntegrationsConfig200ResponseAutotask interface.
 */
export function instanceOfGetIntegrationsConfig200ResponseAutotask(value: object): value is GetIntegrationsConfig200ResponseAutotask {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('apiUserName' in value) || value['apiUserName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('priorities' in value) || value['priorities'] === undefined) return false;
    if (!('dueInDays' in value) || value['dueInDays'] === undefined) return false;
    if (!('triggers' in value) || value['triggers'] === undefined) return false;
    if (!('hasSecret' in value) || value['hasSecret'] === undefined) return false;
    return true;
}

export function GetIntegrationsConfig200ResponseAutotaskFromJSON(json: any): GetIntegrationsConfig200ResponseAutotask {
    return GetIntegrationsConfig200ResponseAutotaskFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseAutotaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200ResponseAutotask {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'apiUserName': json['apiUserName'],
        'companyId': json['companyId'],
        'statusId': json['statusId'],
        'priorities': GetIntegrationsConfig200ResponseAutotaskPrioritiesFromJSON(json['priorities']),
        'queueId': json['queueId'] == null ? undefined : json['queueId'],
        'billingCodeId': json['billingCodeId'] == null ? undefined : json['billingCodeId'],
        'ticketTypeId': json['ticketTypeId'] == null ? undefined : json['ticketTypeId'],
        'dueInDays': json['dueInDays'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON(json['triggers']),
        'hasSecret': json['hasSecret'],
    };
}

export function GetIntegrationsConfig200ResponseAutotaskToJSON(json: any): GetIntegrationsConfig200ResponseAutotask {
    return GetIntegrationsConfig200ResponseAutotaskToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseAutotaskToJSONTyped(value?: GetIntegrationsConfig200ResponseAutotask | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'apiUserName': value['apiUserName'],
        'companyId': value['companyId'],
        'statusId': value['statusId'],
        'priorities': GetIntegrationsConfig200ResponseAutotaskPrioritiesToJSON(value['priorities']),
        'queueId': value['queueId'],
        'billingCodeId': value['billingCodeId'],
        'ticketTypeId': value['ticketTypeId'],
        'dueInDays': value['dueInDays'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersToJSON(value['triggers']),
        'hasSecret': value['hasSecret'],
    };
}

